var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info-modal-template',{attrs:{"name":"app-info-modal","title":_vm.title,"details":_vm.details},on:{"close":_vm.onCloseHandler,"before-open":_vm.onBeforeOpen}})
}
var staticRenderFns = []

export { render, staticRenderFns }